import { Col, Row, Typography } from 'antd';
import React from 'react';
import styles from './App.module.scss';
const { Title } = Typography;

const Header = () => {
  return (
    <div className={styles.header}>
      <Row justify="center">
        <Col>
          <Title>THE MOVIE DATABASE APP</Title>
        </Col>
      </Row>
      <Row justify="center">
        <Col>
          <Title level={4}>Now playing movies (click the image)</Title>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
